import React, { useState, useRef, useEffect, useCallback } from "react";

export const SearchSelect = ({
  placeholder = "Vyhledat...",
  onSearch,
  onSelect,
  renderOption,
  disabled = false,
}) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const wrapperRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const doSearch = useCallback(
    async (searchQuery) => {
      if (!searchQuery || searchQuery.length < 1) {
        setOptions([]);
        setIsOpen(false);
        return;
      }
      setLoading(true);
      try {
        const results = await onSearch(searchQuery);
        setOptions(results);
        setIsOpen(true);
      } catch {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    },
    [onSearch],
  );

  const handleInputChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => doSearch(val), 300);
  };

  const handleSelect = (item) => {
    onSelect(item);
    setQuery("");
    setOptions([]);
    setIsOpen(false);
  };

  return (
    <div className="strat-search-wrapper" ref={wrapperRef}>
      <input
        type="text"
        className="strat-search-input"
        placeholder={placeholder}
        value={query}
        onChange={handleInputChange}
        onFocus={() =>
          query.length >= 1 && options.length > 0 && setIsOpen(true)
        }
        disabled={disabled}
      />
      {isOpen && (
        <div className="strat-search-dropdown">
          {loading && <div className="strat-search-empty">Načítání...</div>}
          {!loading && options.length === 0 && (
            <div className="strat-search-empty">Žádné výsledky</div>
          )}
          {!loading &&
            options.map((item, idx) => (
              <div
                key={item.id || idx}
                className="strat-search-option"
                onClick={() => handleSelect(item)}
              >
                {renderOption ? renderOption(item) : item.name}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};
